<template>
	<v-snackbar
		v-model="showUpdateSnackbar"
		:timeout="-1"
		color="primary"
		location="bottom right"
		variant="elevated"
	>
		<div class="d-flex align-center">
			<v-icon class="mr-2">mdi-download</v-icon>
			<div>
				<div class="subtitle-1 font-weight-medium">New version available</div>
				<div class="caption">Update now to get the latest features</div>
			</div>
		</div>

		<template #actions>
			<v-btn variant="text" color="white" size="small" @click="dismissUpdate">
				Later
			</v-btn>
			<v-btn
				color="white"
				variant="flat"
				size="small"
				:loading="updating"
				@click="handleUpdate"
			>
				Update
			</v-btn>
		</template>
	</v-snackbar>
</template>

<script setup>
import { usePwaUpdate } from "~/composables/pwa/usePwaUpdate"

const props = defineProps({
	autoReload: {
		type: Boolean,
		default: false,
	},
})

const { updateAvailable, updateApp } = usePwaUpdate()

const showUpdateSnackbar = ref(false)
const updating = ref(false)

// Watch for updates and show snackbar
watch(updateAvailable, (newValue) => {
	if (newValue) {
		if (props.autoReload) {
			// Auto-reload without showing snackbar
			handleUpdate()
		} else {
			// Show snackbar for manual update
			showUpdateSnackbar.value = true
		}
	}
})

const handleUpdate = async () => {
	updating.value = true
	try {
		await updateApp()
		// updateApp() will reload the page, so this won't be reached
	} catch (error) {
		console.error("Failed to update app:", error)
		updating.value = false
	}
}

const dismissUpdate = () => {
	showUpdateSnackbar.value = false
	// Update is still available, just hidden
}

// Auto-update on mount if enabled and update is available
onMounted(() => {
	if (props.autoReload && updateAvailable.value) {
		handleUpdate()
	}
})
</script>
